import { Model } from '@vuex-orm/core';
import Image from '@/models/Image';
import ProductSystem from '@/models/ProductSystem';
import ProductSystemPdfImageOverrideAPI from '@/api/ProductSystemPdfImageOverrideAPI';

export default class ProductSystemPdfImageOverride extends Model {
    public static entity = 'productSystemPdfImageOverrides';

    public static fields() {
        return {
            id: this.attr(null),
            config: this.attr([]),
            pdfOfferImage_id: this.attr(null),
            pdfOfferImage: this.belongsTo(Image, 'pdfOfferImage_id'),
            productSystem_id: this.attr(null),
            productSystem: this.belongsTo(ProductSystem, 'productSystem_id'),
        };
    }

    public static async getAll() {
        let overrides;
        try {
            overrides = await ProductSystemPdfImageOverrideAPI.getAll();
        } catch (e) {
            return Promise.reject(e);
        }
        this.create({
            data: overrides.data,
            insertOrUpdate: ['pdfOfferImage', 'productSystem'],
        });
        return Promise.resolve();
    }

    public static async getById(overrideId: string) {
        let override;
        try {
            override = await ProductSystemPdfImageOverrideAPI.getById(overrideId);
        } catch (e) {
            return Promise.reject(e);
        }
        this.insertOrUpdate({
            data: override.data,
            insertOrUpdate: ['pdfOfferImage', 'productSystem'],
        });
        return Promise.resolve(override);
    }

    public static async updateExisting(
        overrideId: string,
        config: any[],
        pdfOfferImageId: string,
        productSystemId: string
    ) {
        let override;
        try {
            override = await ProductSystemPdfImageOverrideAPI.updateExisting(
                overrideId,
                config,
                pdfOfferImageId,
                productSystemId
            );
        } catch (e) {
            return Promise.reject(e);
        }
        await ProductSystemPdfImageOverride.delete(overrideId);
        this.insertOrUpdate({
            data: override.data,
            insertOrUpdate: ['pdfOfferImage', 'productSystem'],
        });
        return Promise.resolve(override);
    }

    public static async createNew(config: any[], pdfOfferImageId: string, productSystemId: string) {
        let newOverride;
        try {
            newOverride = await ProductSystemPdfImageOverrideAPI.createNew(config, pdfOfferImageId, productSystemId);
        } catch (e) {
            return Promise.reject(e);
        }
        this.insertOrUpdate({
            data: newOverride.data,
            insertOrUpdate: ['pdfOfferImage', 'productSystem'],
        });
        return Promise.resolve(newOverride);
    }

    public static async deleteExisting(overrideId: string) {
        try {
            await ProductSystemPdfImageOverrideAPI.deleteExisting(overrideId);
            await ProductSystemPdfImageOverride.delete(overrideId);
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve();
    }

    public id!: string;
    public config!: any[];
    public pdfOfferImage!: Image;
    public productSystem!: ProductSystem;

    [key: string]: any;
}
